import React, { useContext, useEffect } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { OccurrencePropertiesPropsShape } from "../../interfaces/componentTypes";
import { NumericInput } from "./generalUtilities";

export const OccurrenceProperties: React.FunctionComponent<OccurrencePropertiesPropsShape> = ({
  handleOccurrenceAmount,
  context,
  handleContinuous,
}) => {
  const { goalState } = useContext(context);
  const { t } = useContext(TMDataContext);
  let repeatId = "Goal-occurrence-nonContinuous";
  let continuousId = "Goal-occurrence-Continuous";
  let repeatAmountId = "Goal-Frequency-Repeat-Input";
  let repeatAmountText = "goal-repeat-text-span";

  useEffect(() => {
    if (goalState.continuous) {
      handleOccurrenceAmount(null);
      $(`#${repeatAmountId}`).css("background-color", "lightgray");
      $(`#${repeatAmountId}`).css("box-shadow", "none");

      $(`#${repeatAmountText}`).css("color", "lightgray");
      $(`#${repeatAmountId}`).prop("disabled", true);
    } else if (!goalState.continuous) {
      $(`#${repeatAmountId}`).css("background-color", "white");
      $(`#${repeatAmountId}`).css("box-shadow", "-0.5px -0.5px black");
      $(`#${repeatAmountText}`).css("color", "black");
      $(`#${repeatAmountId}`).prop("disabled", false);
    }
  }, [goalState.continuous]);

  const processInputValue = (value) => {
    let inputScreen = new RegExp(/^[1-9][0-9]*$/);
    if (!!inputScreen.exec(value) || value == null) {
      handleOccurrenceAmount(value);
    } else if (value == "") {
      handleOccurrenceAmount(null);
    }
  };

  return (
    <div className="goal-frequency-option align-middle">
      <label className="goal-input-area-title" htmlFor={continuousId}>
        {t("views.goals.headings.occurrence_frequency")}
      </label>
      <div className="occurrence-wrapper">
        <div className="goal-form-radio-button-wrapper secondary-option">
          <input
            className="goal-form-radio-input"
            type="radio"
            id={continuousId}
            name="continuous"
            value="true"
            checked={goalState.continuous}
            onChange={handleContinuous}
          ></input>
          <label htmlFor={continuousId} style={{ marginBottom: "0px" }}>
            {t("views.goals.headings.continuous")}
          </label>
        </div>
        <div className="goal-form-radio-button-wrapper secondary-option">
          <div className="goal-form-radio-button-wrapper">
            <input
              className="goal-form-radio-input"
              type="radio"
              id={repeatId}
              name="continous"
              value="false"
              checked={!goalState.continuous}
              onChange={handleContinuous}
            ></input>
            <label
              htmlFor={repeatId}
              style={{ marginBottom: "0px", marginRight: "7px" }}
            >
              {t("views.goals.headings.occur")}
            </label>
          </div>
          <NumericInput
            id={repeatAmountId}
            handleValue={processInputValue}
            state={
              goalState.occurrenceAmount == null
                ? ""
                : goalState.occurrenceAmount
            }
          />
          <span id="goal-repeat-text-span" style={{ marginLeft: "5px" }}>
            {goalState.occurrenceAmount
              ? goalState.occurrenceAmount > 1
                ? t("views.goals.contexts.occur_times_multiple")
                : t("views.goals.contexts.occur_times_single")
              : ""}
          </span>
        </div>
      </div>
    </div>
  );
};
